module.exports = __webpack_public_path__ + "img/onboarding-second.ab73a0fd.png";